import { FlexWrap } from '@repo/components';
import { Icon } from '@successmode-ktp/kui';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

type Props = {
  refundAmount: number;
  nation: string;
  onClick: () => void;
};

export const RefundAmount = ({ refundAmount, nation, onClick }: Props) => {
  const [amount, setAmount] = useState(refundAmount);

  useEffect(() => {
    setAmount(refundAmount);
  }, [refundAmount]);

  return (
    <Wrapper active={!!refundAmount} onClick={onClick}>
      <Label>{nation === 'KOR' ? '내 환급액' : 'My refunds'}</Label>
      <FlexWrap alignItems='center' gap='6px'>
        <Currency>KRW</Currency>
        <Amount className='notranslate'>{amount.toLocaleString()}</Amount>
        <Icon.ChevronRight fillColor='#777' size={16} />
      </FlexWrap>
    </Wrapper>
  );
};

const Wrapper = styled.button<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => (props.active ? '#fff' : '#5F6165')};
  padding: 16px;
  gap: 20px;
  border-radius: 8px;
  box-shadow: 0 0 20px 0 rgba(174, 191, 204, 0.5);
  width: 100%;
`;

const Label = styled.p`
  color: var(--KTP-Grayscale-Gray_03, #333);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.28px;
`;

const Currency = styled.p`
  color: var(--KTP-Grayscale-Gray_02, #111);
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.36px;
`;

const Amount = styled.p`
  color: var(--KTP-Grayscale-Gray_02, #111);
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.4px;
`;
